import React, { useContext, useMemo } from "react";
import TeaserPayment from "./TeaserPayment";
import GlobalsContext from "../../../context/GlobalsContext";
import { payoutStatus } from "../../../constants";

const TeaserPaymentComponent = props => {
  const globalsContext = useContext(GlobalsContext);

  const errorReasons = globalsContext.reasons[payoutStatus.edit] || [];

  const penaltyReasons = globalsContext.reasons[payoutStatus.penalty] || [];

  const discardReasons = globalsContext.reasons[payoutStatus.fail] || [];

  return (
    <TeaserPayment
      {...props}
      discardReasons={discardReasons}
      errorReasons={errorReasons}
      penaltyReasons={penaltyReasons}
    />
  );
};

export default TeaserPaymentComponent;
